import React, { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"; // install react-router-dom through npm
import { useSelector } from "react-redux";
import Header from "./components/Header/Header";
import PostPreview from "./components/PostPreview/PostPreview";
import Footer from "./components/Footer/Footer";

import Post from "./components/Post/Post";

import CategoriesAside from "./components/Aside/CategoriesAside";
import { selectSearchTerm } from "./features/searchSlice";
import "./App.css";

function App() {
  const [title, setTitle] = useState("AskReddit");

  const searchTerm = useSelector(selectSearchTerm);

  const onChange = (e) => {
    e.preventDefault();
    setTitle(e.target.value);
  };

  return (
    <Router>
      <div className="appMain">
        <Header className="Header" />
        <div className="mainAside">
          <Switch>
            <div className="post-preview">
              <Route
                path="/"
                exact
                render={() => (
                  <PostPreview name={title} term={searchTerm} isAuthed={true} />
                )}
              />

              <Route path="/r/:subreddit/:comment/:id" component={Post} />
            </div>
          </Switch>

          <section className="aside">
            <CategoriesAside onchange={onChange} name={title} />
          </section>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
